var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',{staticClass:"facebook-btn",on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fab fa-facebook-f"})])
}
var staticRenderFns = []

export { render, staticRenderFns }